import React from "react";
import { Link } from "react-router-dom";

// Components
import Button from "./Button";
import BlackDiv from "./BlackDiv";

// CSS
import "../../css/sections/section-banner.css";

class SectionBanner extends React.PureComponent {
	render() {
		return (
			<div
				className={
					"section-banner" + (!!this.props.classes ? ` ${this.props.classes}` : ``)
				}
			>
				<div className={`section-banner--title` + (this.props.bold ? ` title--bold` : "")}>
					{this.props.children}
				</div>
				{this.props.link && (
					<Link className="section-banner--side-link" to={this.props.link.href}>
						<span>{this.props.link.title}</span>
					</Link>
				)}
				{this.props.outsideLink && (
					<a
						className="section-banner--side-link"
						href={this.props.outsideLink.href}
						target="_blank"
						rel="noopener noreferrer"
					>
						<span>{this.props.outsideLink.title}</span>
					</a>
				)}
				{this.props.button && (
					<Button
						classes={this.props.button.classes}
						clickHandler={this.props.button.onClick}
						isDisabled={this.props.button.isDisabled}
						text={this.props.button.text}
					/>
				)}
				{this.props.div && <BlackDiv>{this.props.div.text}</BlackDiv>}
			</div>
		);
	}
}

export default SectionBanner;



// WEBPACK FOOTER //
// ./src/components/utils/SectionBanner.js